const newEquipmentType = {
  snackbar: "Your update is ready",
  name: "Asset Type Name",
  save: "Save",
  cancel: "Cancel",
  area: "Asset Type",
  formTitle: "Asset Type",
  isPump: "Is a pump?",
  confirm: "Are you sure you want to delete this item?",
  close: "Close",
  delete: "Delete"
};
export default newEquipmentType;
